"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./DemoSettingsStaticComponent.css");
var _ContentWithHeaderLayoutTemplate = _interopRequireDefault(require("../../common/LayoutTemplates/ContentWithHeaderLayoutTemplate/ContentWithHeaderLayoutTemplate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var demoSettingsStaticClasses = (0, _cssClassesHelper.getBEMClasses)('demo-settings-static');
var demoSettingsWidgetsClasses = (0, _cssClassesHelper.getBEMClasses)('demo-settings-widget');
var DemoSettingsStaticComponent = function DemoSettingsStaticComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  var goToNextStep = props.goToNextStep,
    formValues = props.formValues;
  return /*#__PURE__*/_react["default"].createElement(_ContentWithHeaderLayoutTemplate["default"], {
    header: /*#__PURE__*/_react["default"].createElement("div", {
      className: demoSettingsWidgetsClasses('header')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: demoSettingsWidgetsClasses('header-text')
    }, t('Settings'))),
    customClass: demoSettingsWidgetsClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: demoSettingsStaticClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: demoSettingsStaticClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Template'),
    text: formValues.template,
    customClass: demoSettingsStaticClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: demoSettingsStaticClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Color Theme'),
    text: formValues.theme,
    customClass: demoSettingsStaticClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: demoSettingsStaticClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Chart Type'),
    text: formValues.chart,
    customClass: demoSettingsStaticClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: demoSettingsStaticClasses('button-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: demoSettingsStaticClasses(),
    onClick: function onClick() {
      return goToNextStep();
    }
  }, t('Edit')))));
};
DemoSettingsStaticComponent.defaultProps = {};
DemoSettingsStaticComponent.propTypes = {
  customClass: _propTypes["default"].string,
  goToNextStep: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = DemoSettingsStaticComponent;